




import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class FontSizeDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  get options(): StandardOption<number>[] {
    return Enumerable.from(this.fontSizes)
      .select(s => new StandardOption<number>(s.toString(), s))
      .toArray();
  }

  get fontSizes(): number[] {
    return ((this.editingSource && FontSizeDropDownSelector._defaultFontSizes.indexOf(this.editingSource) < 0) ? [ this.editingSource ] : [])
      .concat(FontSizeDropDownSelector._defaultFontSizes);
  }

  private static readonly _defaultFontSizes: number[] = [
    8,
    9,
    10,
    11,
    12,
    14,
    16,
    18,
    20,
    22,
    24,
    26,
    28,
    36,
    48,
    72,
    108,
    156,
    216,
  ];
}
